import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import RSelect from "react-select";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";
import Select from "react-select";
function MultiSelect({
  data,
  defaultValue,
  isInputFieldTouched,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  //Select child -Lovejot(12-DEC-2022)
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState([]);

  const [element, setElement] = useState({
    type: "multiSelect",

    properties: {
      label: "MultiSelect field.",
      options: [],
      value: [],
    },
    multiple: false,
    required: false,
  });

  const [value, setValue] = useState();

  const [readOnly, setReadOnly] = useState(false);

  async function showData() {
    setValue(data.properties.value !== null ? data.properties.value : "");
    // await setElement(data);
    if (data.properties.label === "How did you come to know about us") {
      //console.log("data.properties.value", data.properties.value)
      if (
        data?.properties?.value?.length === 0 ||
        data.properties.value === undefined
      ) {
        setReadOnly(false);
      }
      // else if(data?.properties?.value === "WALKIN_QR"){
      //   setReadOnly(false)
      // }
      else {
        // await setValue(data.properties.value);
        setReadOnly(true);
      }
    }
  }

  useEffect(() => {
    showData();
    let val = data?.properties?.value;
    let safeArr = Array.isArray(val)
      ? val
      : typeof val === "string" && val.trim()
      ? val.split(",").map((s) => s.trim())
      : [];
    setElement((prev) => ({
      ...prev,
      ...data,
      properties: {
        ...data?.properties,
        value: safeArr,
      },
    }));
  }, [data, isChild]);

  const handleMultipleValues = (e) => {
    let o = { ...element };
    let arr = [];

    if (e !== null) {
      for (const ele of e) {
        arr.push(ele.value);
        // setElement({
        //     ...element,
        //     value:[...element.value,ele.value]
        // })
      }
      o.properties.value = [...arr];
      //  o.value = [...arr]
      setElement({ ...o });
    } else {
      o.properties.value = [];
      setElement({ ...o });
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group mb-3 col-md-12 form-builder-element">
      <label htmlFor="">
        {element?.properties?.label}
        <If test={element?.properties?.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>

      <div
        className="form-view"
        label={element?.properties?.label}
        data={JSON.stringify(element)}
      >
        <Select
          closeMenuOnSelect={false}
          isMulti
          value={(Array.isArray(element?.properties?.value)
            ? element.properties.value
            : typeof element?.properties?.value === "string" && element.properties.value.trim()
            ? element.properties.value.split(",").map((s) => s.trim())
            : []
          ).map((option) => {
            return {
              label: option,
              value: option,
            };
          })}
          options={element.properties.options.map((option) => {
            return {
              label: option,
              value: option,
            };
          })}
          className={`${foundError ? "border border-danger" : ""}`}
          isDisabled={
            approve ||
            !element.editable ||
            (defValue && hasChiledReadOnly) ||
            ocrDisabled
          }
          onChange={(e) => {
            handleMultipleValues(e);
            if (isInputFieldTouched) {
              isInputFieldTouched();
            }
          }}
        ></Select>
        {foundError && <p className="text-danger">{foundError?.value}</p>}
      </div>
    </div>
  );
}

export default MultiSelect;
